module.exports = __webpack_public_path__ + "static/media/lds-logo_is.1b756329.svg";